<template>
    <div class="w-100">
        <label
            for="background_image_opacity"
            class="font-14"
        >
            {{ opacity.name }}
        </label>

        <div class="row">
            <input
                class="mx-4 col-2 form-control" 
                type="number"
                name="background_image_opacity_number"
                id="background_image_opacity_number"
                v-model="item.extra.background_image_opacity"
                :min="opacity.min_value"
                :max="opacity.max_value"
                @input="$emit('onChangeBackgroundImageOpacity', $event.target.value)"
            >

            <input
                class="mx-4 col-4" 
                type="range"
                name="background_image_opacity"
                id="background_image_opacity"
                v-model="item.extra.background_image_opacity"
                :min="opacity.min_value"
                :max="opacity.max_value"
                @input="$emit('onChangeBackgroundImageOpacity', $event.target.value)"
            >
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'SettingFrameBackgroundImageOpacity',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            opacity: {}
        }
    },
    computed: {
        ...mapGetters('dashboardModule', ['getFrameImageOpacity']),
    },
    mounted() {
        this.opacity = this.getFrameImageOpacity;

        // quando o frame não tem a propriedade background_image_opacity, seta o valor default
        if (!this.item.extra.background_image_opacity) {
            this.$emit('onChangeBackgroundImageOpacity', this.opacity.default);
        }
    }
}
</script>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */

   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
   border-radius: 50%;
}

input[type="range"]:focus::-webkit-slider-thumb {   
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameBackgroundImageOpacity.vue